export default "__VITE_ASSET__DSrib2Td__"